import { Box } from '@mui/material';
import styled from 'styled-components';
import { colors } from '../../theme';

export const ColorSwatchBox = styled(Box)`
    && {
        cursor: pointer;
        border-radius: 8px;
        padding: 8px 15px;
        background-color: 'transparent';

        &:hover {
            background-color: ${colors.grey000};
            cursor: pointer;
            transition: background-color 500ms ease-in-out;
            border-radius: 8px;
        }
        width: 137px;
        text-align: center;
    }
`;

export const ColorContainer = styled.div`
    && {
        display: flex;
        flex-direction: row;
        gap: 5px;
        align-items: center;
        justify-content: center;
    }
`;
